export default {
  Conversion: 1, 
  Extension: 2,
  Exploration: 3,
  Geotechnical: 4,
  Delineation: 5,
  Definition: 6,
  ServiceHole: 7,
  Unknown : 99
};